import * as v from 'valibot';
import { TimestampSchema, UsernameSchema } from './common';
// =============================================================================
// Admin Schemas
// =============================================================================
export const AdminIdentityObjectSchema = v.object({
    username: v.string(),
    state: v.picklist(['ACTIVE', 'EXPIRED', 'OWNED_UNPAID']),
    created_at: TimestampSchema,
    expires_at: v.nullable(TimestampSchema),
    mail_public_key: v.nullable(v.string()),
});
export const ProvisionIdentitySchema = v.object({
    username: UsernameSchema,
});
export const AdminListIdentitiesRequestSchema = v.object({
    limit: v.optional(v.number()),
    offset: v.optional(v.number()),
    search: v.optional(v.string()),
});
export const AdminListIdentitiesResponseSchema = v.object({
    identities: v.array(AdminIdentityObjectSchema),
    total: v.number(),
});
export const AdminStatsResponseSchema = v.object({
    totalIdentities: v.number(),
    activeSubscriptions: v.number(),
    recentMessages: v.number(),
});
export const AdminGetIdentityResponseSchema = AdminIdentityObjectSchema;
export const AdminLogsRequestSchema = v.object({
    limit: v.optional(v.number()),
    offset: v.optional(v.number()),
    level: v.optional(v.string()),
    source: v.optional(v.string()),
    requestId: v.optional(v.string()),
    userId: v.optional(v.string()),
});
export const AdminLogsResponseSchema = v.object({
    logs: v.array(v.object({
        id: v.string(),
        timestamp: TimestampSchema,
        level: v.string(),
        source: v.string(),
        message: v.string(),
        identity_id: v.nullable(v.string()),
        metadata: v.nullable(v.string()),
    })),
    total: v.number(),
    limit: v.number(),
    offset: v.number(),
});
// =============================================================================
// Log Schema
// =============================================================================
export const LogEntrySchema = v.object({
    source: v.string(),
    level: v.picklist(['info', 'warn', 'error', 'debug']),
    message: v.pipe(v.string(), v.minLength(1)),
    metadata: v.optional(v.record(v.string(), v.any())),
});
export const IdentityStatusResponseSchema = v.object({
    username: v.string(),
    identity_id: v.string(),
    state: v.string(),
    subscription_expires_at: v.nullable(TimestampSchema),
    ever_activated: v.boolean(),
    created_at: TimestampSchema,
    km_recovery_wrap: v.nullable(v.string()),
    recovery_salt: v.nullable(v.string()),
    recovery_kdf_params: v.nullable(v.string()),
    mail_public_key: v.nullable(v.string()),
    km_v: v.number(),
});
//# sourceMappingURL=admin.js.map